import { IUser } from '~/models';
import { selectedOfficeApi, type IGetSelectedOfficeParams } from './selectedOfficeApi';

async function getSelectedOffice(params: IGetSelectedOfficeParams = {}): Promise<IUser> {
  return selectedOfficeApi.getSelectedOffice(params);
}

export const selectedOfficeService = {
  getSelectedOffice,
};
